module.exports = __webpack_public_path__ + "static/media/img-1-1000x900.b20ea51c.jpg";